module.exports = __webpack_public_path__ + "static/img/wl-img3.f8e5678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wl-img3.jpg
// module id = 610
// module chunks = 0